import { render, staticRenderFns } from "./contact-match-panel.vue?vue&type=template&id=2299c080"
import script from "./contact-match-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./contact-match-panel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports